// This component is meant to be rendered as a child of myAccount Route's component.

import React, { useState, useEffect } from "react"
import { BaseUrl } from "../utils/config"
import { useNavigate } from "@reach/router"
import { connect, useSelector, useDispatch } from "react-redux"
import {
  updateUserDetailsRedux,
  setPendingPayment,
  updateOrderCount,
  setConnectedWallet,
  setActiveMenu
} from "../../redux/actions"
import { Popconfirm } from "antd"
import axios from "axios"
import swal from "sweetalert"
import moment from "moment"
//Style
import "../../assets/css/pendingPayments.css"

//Images
import mysterImage from "../../assets/images/myster.png"
import mineGlobally from "../../assets/images/mineglobalwhite.png"
import weHostYouMine from "../../assets/images/minerwhites.png"
import effortlessEarning from "../../assets/images/effortlesswhite.png"
import collectible from "../../assets/images/collectiblewts.png"
import payBoxBackgroundGradient from "../../assets/images/pay-bg.png"
import * as FaIcons from "react-icons/fa"

import Modal from "../components/Modal"
import Dropdown from "../components/dropdown"

// ⚠️⚠️⚠️ Attention - Please don't make any changes⚠️⚠️⚠️
// ⚠️⚠️⚠️ Blockchain Integration Start ⚠️⚠️⚠️ //

import nftAbi from "../../assets/blockchain/nftAbi.json"
import constant from "../../constants/constants"
import Web3 from "web3"
import Cookies from "universal-cookie"
import { Tooltip } from "antd"
import { isFloat } from "../../utils"
const cookies = new Cookies()

// ⚠️⚠️⚠️ Attention - Please don't make any changes ⚠️⚠️⚠️
// ⚠️⚠️⚠️ Blockchain Integration End ⚠️⚠️⚠️ //

function PendingPayments({
  updateUserDetails,
  updateConnectedWallet,
  fetchUserInfo
}) {
  var addCommas = require("add-commas")
  const loginUserId = localStorage.getItem("loginUserId")
  const loginUserToken = localStorage.getItem("loginUserToken")
  const userDetails = useSelector(state => state.common.userDetails) || {}
  const pendingPayment =
    useSelector(state => state.common.pendingPayment) || null

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [order, setOrder] = useState(
    Array.isArray(pendingPayment?.data) ? pendingPayment?.data : []
  )

  const subTabs = [
    { image: mineGlobally, label: "Mine Globally", class: "first" },
    { image: weHostYouMine, label: "We Host You Mine", class: "second" },
    { image: effortlessEarning, label: "Effortless Earning", class: "third" },
    { image: collectible, label: "Collectible", class: "fourth" }
  ]
  const [paymentInProgress, setPaymentInProgress] = useState("")
  const [payButtonClicked, setPayButtonClicked] = useState(false)

  // ⚠️⚠️⚠️ Attention - Please don't make any changes ⚠️⚠️⚠️
  // ⚠️⚠️⚠️ Blockchain Integration Start ⚠️⚠️⚠️ //

  let [web3, setWeb3] = useState(null)
  let [isWalletConnected, setWalletConnected] = useState(false)
  let [connectedWallet, setConnectedWallet] = useState(null)
  let [viewModal, setViewModal] = useState(false)
  let modalDropdown = [
    { value: "", label: "Select Token" },
    { value: "2", label: "2" }
  ]
  let [token, setToken] = useState(modalDropdown[0].value)

  const connectToWallet = async () => {
    console.log(
      `[nft][src][components][components][pages][pendingPayments][connectToWallet] connectToWallet`
    )
    if (typeof window.ethereum !== "undefined") {
      let accounts = await window.ethereum.request({
        method: "eth_requestAccounts"
      })
      window.web3 = new Web3(window.ethereum)
      setWeb3(window.web3)
      let chainId = await window.web3.eth.getChainId()
      // if (chainId !== parseInt(constant.CHAIN_ID)) {
      //   swal({
      //     title: "Invalid Network!",
      //     text: `Switch your network to ${constant.NETWORK_NAME}`,
      //     icon: "error",
      //     confirmButtonText: "Ok",
      //   });
      //   return;
      // }
      cookies.set("wallet", accounts[0], { path: "/" })
      cookies.set("wallet_status", 1, { path: "/" })
      setWalletConnected(true)
      setConnectedWallet(accounts[0])
      setWeb3(window.web3)
    } else {
      cookies.set("wallet", null, { path: "/" })
      cookies.set("wallet_status", 0, { path: "/" })
      setWalletConnected(false)
      setConnectedWallet(null)
      setWeb3(null)
      // swal({
      //   title: "Unsupported Browse/Plugin not installed",
      //   text: `Please use Google Chrome with Metamask Plugin Installed`,
      //   icon: "error",
      //   confirmButtonText: "Ok",
      // });
      console.log("Unsupported Browser/Plugin not installed")
    }
  }

  const toggleModalView = () => {
    setViewModal(prevState => !prevState)
  }

  const checkIfWalletAlreadyConnected = async () => {
    let walletStatus = cookies.get("wallet_status")
    let connectedWallet = cookies.get("wallet")
    if (parseInt(walletStatus) == 1) {
      console.log(
        `[nft][src][components][components][pages][pendingPayments][checkIfWalletAlreadyConnected] walletStatus 1 ${walletStatus}`
      )
      if (connectedWallet !== null || connectedWallet !== undefined) {
        cookies.set("wallet", connectedWallet, { path: "/" })
        cookies.set("wallet_status", 1, { path: "/" })
        setWalletConnected(true)
        setConnectedWallet(connectedWallet)
        setWeb3(web3)
      }
    } else {
      console.log(
        `[nft][src][components][components][pages][pendingPayments][checkIfWalletAlreadyConnected] walletStatus 2 ${walletStatus}`
      )
      cookies.set("wallet", null, { path: "/" })
      cookies.set("wallet_status", 0, { path: "/" })
      setWalletConnected(false)
      setConnectedWallet(null)
      setWeb3(null)
    }
  }

  // ⚠️⚠️⚠️ Attention - Please don't make any changes ⚠️⚠️⚠️
  // ⚠️⚠️⚠️ Blockchain Integration End ⚠️⚠️⚠️ //

  const getPendingPayments = () => {
    if (userDetails?.loginUserToken) {
      axios
        .get(`${BaseUrl}/mypurchase/${loginUserId}`, {
          headers: {
            Authorization: `Bearer ${loginUserToken}`
          }
        })
        .then(response => {
          let distructedResponse = response?.data ?? null
          if (response.status === 200) {
            if (distructedResponse?.is_payment_in_progress) {
              setPaymentInProgress(distructedResponse?.message ?? "")
            } else if (
              distructedResponse?.is_payment_completed &&
              !localStorage.getItem("buyNitroToken")
            ) {
              navigate("/myaccount/mycollection")
              dispatch(setActiveMenu("NFM"))
            }
            dispatch(setPendingPayment(response?.data ?? null))
          } else if (response?.status == 401) {
            dispatch(updateUserDetailsRedux({}))
            dispatch(setConnectedWallet(""))
            localStorage.clear()
            navigate("/login")
          } else if (response?.status == 404) {
            swal({
              title: "Error!",
              text: "Page not found. Please try again later.",
              icon: "error"
            })
          } else if (response?.status == 500) {
            swal({
              title: "Error!",
              text: "Something went wrong. Please try again later.",
              icon: "error"
            })
          } else if (response?.status == 503) {
            swal({
              title: "Error!",
              text: "Something went wrong. Please try again later.",
              icon: "error"
            })
          } else {
            dispatch(setPendingPayment(null))
          }
        })
        .catch(err => {
          dispatch(setPendingPayment(null))
          if (err?.response?.status === 401) {
            localStorage.clear()
            updateUserDetails({})
            navigate("/login")
          }
        })
    } else {
      navigate("/login")
    }
  }

  useEffect(() => {
    addHoverListeners()
    checkIfWalletAlreadyConnected()
    getPendingPayments()
    return () => {
      removeHoverListeners()
    }
  }, [])

  useEffect(() => {
    setOrder(Array.isArray(pendingPayment?.data) ? pendingPayment?.data : [])
  }, [pendingPayment])

  let data =
    pendingPayment && Array.isArray(pendingPayment.data)
      ? pendingPayment.data
      : []

  let categorizedOrders = {
    Iconic: [],
    Premium: [],
    "Top Location": []
  }

  if (data?.length) {
    Object.keys(categorizedOrders).forEach((key, index) => {
      categorizedOrders[key] = data.filter(
        orderItem => parseInt(orderItem.product_id) - 1 === index
      )
    })
  }

  const updateCount = (orderId, action) => {
    let updatedOrders = []
    switch (action) {
      case "plus":
        updatedOrders = order.map(order =>
          order.order_id === orderId
            ? { ...order, device_count: order.device_count + 1 }
            : { ...order }
        )
        break
      case "minus":
        updatedOrders = order.map(order =>
          order.order_id === orderId
            ? { ...order, device_count: order.device_count - 1 }
            : { ...order }
        )
        break
    }
    setOrder(updatedOrders)
  }

  // useEffect(() => {
  //   if (pendingPayment?.data) {
  //     let tempData = [...pendingPayment.data];
  //     let pendingArray = tempData.map(
  //       (value) => value.unit_price * value.device_count
  //     );
  //     let total_amount = pendingArray.reduce((p, c) => p + c);
  //     setAmount(total_amount);
  //   }
  // }, [pendingPayment]);

  const updateOrder = (count, id) => {
    let data = {
      qty: count,
      order_id: id
    }

    axios
      .post(`${BaseUrl}/addorderquatity`, data, {
        headers: {
          // 'Content-Type': 'application/json',
          Authorization: `Bearer ${loginUserToken}`
        }
      })
      .then(response => {
        if (response.status == 200) {
          getPendingPayments()
          fetchUserInfo()
          swal({
            title: "Success!",
            text: "Order updated successfully",
            icon: "success"
          })
        }
      })
      .catch(error => {
        if (error?.response?.status === 401) {
          localStorage.clear()
          updateUserDetails({})
          updateConnectedWallet("")
          navigate("/login")
        } else if (error?.response?.status == 500) {
          swal({
            title: "Error!",
            text: error.message,
            icon: "error"
          })
        } else {
          swal({
            title: "Error!",
            text: "Something went wrong. Please try again later.",
            icon: "error"
          })
        }
      })
  }

  return (
    <>
      {/* <div className="nitro-hero-section">
        <div className="nitro-img">
          <img src={mysterImage} alt="BOX" />
        </div>

        <div className="nitro-text">
          <h1 id="gradient-text" className="gradient-text max-width-full">
            Your Nitro NFM (Non-Fungible Miner)
          </h1>
          <h5>Reap unending rewards, effortlessly.</h5>
          <p id="pp-desc">
            Your digital mining journey with Nitro has begun with your Nitro
            NFM. This NFM is the gateway to mine effortlessly from anywhere in
            the world! It holds limitless potential to earn rewards.
          </p>
          <div className="nitro-text-inside-section">
            <div className="four-link">
              {subTabs.map((subTab, index) => (
                <a
                  key={subTab.class + index}
                  className={"link-hover " + subTab.class}
                >
                  <img src={subTab.image} alt={subTab.label} />
                  {subTab.label}
                </a>
              ))}
            </div>

            <div className="full-content-box">
              <div>
                <img src={mineGlobally} alt="" className="image-box" />
                <h4 className="head-box">Mine Globally</h4>

                <p className="text-box">
                  Your NFM is limitless and borderless. Build the Nitro Network
                  and mine effortlessly, anywhere in the world!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {pendingPayment && Array.isArray(pendingPayment?.data) ? ( // UI for successful information fetch
        <>
          <h2 className="content-head-pending-payment">Order Details</h2>
          <table
            id="order-table"
            className="table de-table table-rank table-font-size-reduce table-responsive">
            <thead>
              <tr>
                {/* <th scope="col" className="first-head">
                  Order ID
                </th> */}
                <th scope="col" className="right">
                  Device Count
                </th>
                <th scope="col" className="right">
                  Tier
                </th>
                {/* <th scope="col" className="right">
                  Order Date
                </th> */}
                <th scope="col" className="right">
                  Pending Amount
                </th>
                <th scope="col" className="right">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {order.map((orderItem, index) => {
                return (
                  <tr key={orderItem?.order_id + index}>
                    {/* <td className="right" data-label="Order ID">
                      {orderItem?.order_id}
                    </td> */}
                    <td className="right" data-label="Device Count">
                      <div className="counter in-mobile-right">
                        {!orderItem.payment_gross ? (
                          <p
                            style={{ padding: "3px 7px", fontSize: "1.2rem" }}
                            className={`minus${
                              !orderItem.device_count ? " disabled" : ""
                            }`}
                            onClick={
                              orderItem.device_count
                                ? () => updateCount(orderItem.order_id, "minus")
                                : () => {}
                            }>
                            -
                          </p>
                        ) : null}
                        &nbsp;&nbsp;
                        {orderItem.device_count}&nbsp;&nbsp;
                        {!orderItem.payment_gross ? (
                          <p
                            style={{ padding: "3px 7px", fontSize: "1.2rem" }}
                            className="plus"
                            onClick={() =>
                              updateCount(orderItem.order_id, "plus")
                            }>
                            +
                          </p>
                        ) : null}
                      </div>
                    </td>
                    <td className="d-plus right" data-label="Tier">
                      {
                        {
                          1: "Iconic",
                          2: "Premium",
                          3: "Top"
                        }[orderItem?.product_id]
                      }
                    </td>
                    {/* <td className="right max-time" data-label="Order Date">
                      <span className="time-font">
                        {moment(orderItem?.createdAt).format("DD-MMM-YYYY")}
                      </span>
                    </td> */}
                    <td className="right" data-label="Pending Amount">
                      $
                      {!orderItem.payment_gross
                        ? !isFloat(
                            (orderItem?.unit_price ?? 0) *
                              (orderItem?.device_count ?? 0)
                          )
                          ? addCommas(
                              (orderItem?.unit_price ?? 0) *
                                (orderItem?.device_count ?? 0)
                            )
                          : orderItem?.unit_price *
                            (orderItem?.device_count ?? 0)
                        : !isFloat(orderItem?.pending_amount ?? 0)
                        ? addCommas(orderItem?.pending_amount ?? 0)
                        : orderItem?.pending_amount ?? 0}
                    </td>
                    <td className="right" data-label="Action">
                      {!orderItem.payment_gross ? (
                        <button
                          style={{
                            padding: "6px auto 6px",
                            textAlign: "center",
                            fontWeight: "normal"
                          }}
                          className="gradient-box"
                          onClick={() =>
                            updateOrder(
                              orderItem?.device_count,
                              orderItem?.order_id
                            )
                          }>
                          Update Qty
                        </button>
                      ) : (
                        "Payment is already made and so, this order is not editable."
                      )}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          {payButtonClicked || paymentInProgress ? (
            <p
              className="text-left"
              style={{
                display: "block",
                color: "white",
                margin: `15px ${viewModal ? "0" : "auto"}`,
                textAlign: "center",
                maxWidth: "70%",
                fontWeight: "bold",
                fontSize: "1.01rem"
              }}>
              Payment is under process. Upon network confirmation & confirmation
              from payment processor, mystery box(s) will show up under "My
              Collection". In case of failure of payment, please wait for some
              time until "Pay Now" buttons get re-activated, to retry the
              payment.
            </p>
          ) : null}

          <h2 className="content-head-pending-payment">Order Summary</h2>
          <div className="payment-bar mt-2">
            <div>
              <p>
                Device count &nbsp;
                <Tooltip title="Number of devices ordered">
                  <FaIcons.FaExclamationCircle />
                </Tooltip>
              </p>
              <h1 className="payment-bar-info">
                {(pendingPayment?.data ?? [])
                  .map(orderItem => orderItem?.device_count ?? 0)
                  .reduce((pval, cval) => pval + cval, 0)}
              </h1>
              <ul style={{ color: "#fff" }}>
                {/* {pendingPayment?.data?.map((orderItem, index) => (
                <li key={orderItem.product_id + index}>
                  {categories[parseInt(orderItem.product_id) - 1]} -{" "}
                  {orderItem.device_count}
                </li>
              )) ?? null} */}
                {Object.entries(categorizedOrders).map((entry, index) => {
                  if (entry[1].length) {
                    return (
                      <li key={entry[0] + index}>
                        {`${entry[0]} -
                        ${entry[1].reduce(
                          (pval, cval) => pval + cval?.device_count ?? 0,
                          0
                        )}`}
                      </li>
                    )
                  } else return null
                })}
              </ul>
            </div>
            <div>
              <p>
                Total Due &nbsp;{" "}
                <Tooltip title="Total cost">
                  <FaIcons.FaExclamationCircle />
                </Tooltip>
              </p>
              <h1 className="payment-bar-info">
                $
                {!isFloat(
                  (pendingPayment?.data ?? [])
                    .map(
                      orderItem =>
                        (orderItem?.payment_gross ?? 0) +
                        (orderItem?.pending_amount ?? 0)
                    )
                    .reduce((pval, cval) => pval + cval, 0)
                )
                  ? addCommas(
                      (pendingPayment?.data ?? [])
                        .map(
                          orderItem =>
                            (orderItem?.payment_gross ?? 0) +
                            (orderItem?.pending_amount ?? 0)
                        )
                        .reduce((pval, cval) => pval + cval, 0)
                    )
                  : (pendingPayment?.data ?? [])
                      .map(
                        orderItem =>
                          (orderItem?.payment_gross ?? 0) +
                          (orderItem?.pending_amount ?? 0)
                      )
                      .reduce((pval, cval) => pval + cval, 0)}
              </h1>
            </div>
            <div>
              <p>
                Paid &nbsp;{" "}
                <Tooltip title="Total paid amount at the time of pre-order">
                  <FaIcons.FaExclamationCircle />
                </Tooltip>
              </p>
              <h1 className="payment-bar-info">
                $
                {!isFloat(
                  (pendingPayment?.data ?? [])
                    .map(orderItem => orderItem?.payment_gross ?? 0)
                    .reduce((pval, cval) => pval + cval, 0)
                )
                  ? addCommas(
                      (pendingPayment?.data ?? [])
                        .map(orderItem => orderItem?.payment_gross ?? 0)
                        .reduce((pval, cval) => pval + cval, 0)
                    )
                  : (pendingPayment?.data ?? [])
                      .map(orderItem => orderItem?.payment_gross ?? 0)
                      .reduce((pval, cval) => pval + cval, 0)}
              </h1>
            </div>
            <div>
              <p>
                Balance &nbsp;
                <Tooltip title="Total outstanding payable amount">
                  <FaIcons.FaExclamationCircle />
                </Tooltip>
              </p>
              <div className="row-style">
                <h1 className="gradient-text payment-bar-info">
                  $
                  {!isFloat(
                    (pendingPayment?.data ?? [])
                      .map(orderItem => orderItem?.pending_amount ?? 0)
                      .reduce((pval, cval) => pval + cval, 0)
                  )
                    ? addCommas(
                        (pendingPayment?.data ?? [])
                          .map(orderItem => orderItem?.pending_amount ?? 0)
                          .reduce((pval, cval) => pval + cval, 0)
                      )
                    : (pendingPayment?.data ?? [])
                        .map(orderItem => orderItem?.pending_amount ?? 0)
                        .reduce((pval, cval) => pval + cval, 0)}
                </h1>
                <div id="payment-btns">
                  <a
                    onClick={() => {
                      navigate("/payment")
                    }}
                    className="gradient-box">
                    Pay Now
                  </a>
                </div>
              </div>
            </div>

            <Modal
              showModal={viewModal}
              toggleModalView={toggleModalView}
              balance={(pendingPayment?.data ?? [])
                .map(orderItem => orderItem?.pending_amount ?? 0)
                .reduce((pval, cval) => pval + cval, 0)}
              deviceCount={(pendingPayment?.data ?? [])
                .map(orderItem => orderItem?.device_count ?? 0)
                .reduce((pval, cval) => pval + cval, 0)}
              setPayButtonClicked={setPayButtonClicked}
              paymentInProgress={paymentInProgress}
            />

            <img
              src={payBoxBackgroundGradient}
              alt="Payment Background"
              id="pay-bg"
            />
            <img
              src={payBoxBackgroundGradient}
              alt="Payment Background"
              id="pay-bg2"
            />
          </div>
        </>
      ) : null}
      <div>
        <p className="text-center mb-0 mt-4">(Powered by Federal)</p>
      </div>
    </>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    updateUserDetails: payload => dispatch(updateUserDetailsRedux(payload)),
    updateConnectedWallet: payload => dispatch(setConnectedWallet(payload))
  }
}

export default connect(null, mapDispatchToProps)(PendingPayments)

function addHoverListeners() {
  const imageBox = document.querySelector(".image-box")
  const headBox = document.querySelector(".head-box")
  const textBox = document.querySelector(".text-box")
  const fourth = document.querySelector(".fourth")
  const third = document.querySelector(".third")
  const second = document.querySelector(".second")
  const first = document.querySelector(".first")

  fourth &&
    fourth.addEventListener("mouseover", function () {
      imageBox.src = collectible
      headBox.innerHTML = "Collectible"
      textBox.innerHTML =
        "Your NFM not only unlocks mining rewards but is also a generative art collectible which is rare and sought after. So, hold on to it!"
    })

  third &&
    third.addEventListener("mouseover", function () {
      imageBox.src = effortlessEarning
      headBox.innerHTML = "Effortless Earning"
      textBox.innerHTML =
        "Buy your Nitro NFM from the marketplace, find your Nest (host) and mine away. It’s effortlessly earning, equitable reward distribution and with no hassles of network congestion!"
    })

  second &&
    second.addEventListener("mouseover", function () {
      imageBox.src = weHostYouMine
      headBox.innerHTML = "We Host You Mine"
      textBox.innerHTML =
        "Nitro Nesters (those who host the network) are present in strategic locations across the world. Nitro platform creates the ideal match for your miner to the Nester so you can earn in the best way."
    })

  first &&
    first.addEventListener("mouseover", function () {
      imageBox.src = mineGlobally
      headBox.innerHTML = "Mine Globally"
      textBox.innerHTML =
        "Your NFM is limitless and borderless. Build the Nitro Network and mine effortlessly, anywhere in the world!"
    })
}

function removeHoverListeners() {
  const imageBox = document.querySelector(".image-box")
  const headBox = document.querySelector(".head-box")
  const textBox = document.querySelector(".text-box")
  const fourth = document.querySelector(".fourth")
  const third = document.querySelector(".third")
  const second = document.querySelector(".second")
  const first = document.querySelector(".first")

  fourth &&
    fourth.removeEventListener("mouseover", function () {
      imageBox.src = "./images/collectiblewts.png"
      headBox.innerHTML = "Collectible"
      textBox.innerHTML = "Rewards are collectible into your account!"
    })
  third &&
    third.removeEventListener("mouseover", function () {
      imageBox.src = "./images/effortlesswhite.png"
      headBox.innerHTML = "Effortless Earning"
      textBox.innerHTML = "You Dont have to work for that, thats effortless!"
    })

  second &&
    second.removeEventListener("mouseover", function () {
      imageBox.src = "./images/minerwhites.png"
      headBox.innerHTML = "We Host You Mine"
      textBox.innerHTML = "We are hosting , Mining Reward you will receive"
    })
  first &&
    first.removeEventListener("mouseover", function () {
      // first.firstElementChild.src = './images/mineglobal.png';
      imageBox.src = "./images/mineglobal.png"
      headBox.innerHTML = "Mine Globally"
      textBox.innerHTML =
        "Your NFT Miner is universal and borderless. Mine anywhere in the world"
    })
}
